import { Action } from 'redux';
import { Product, ProductCode, BillingPlan } from '@dev/ee-api/ee-api-models';
import { GoogleAnalyticsEventsEnum } from '@api/services/dictionaries/GoogleAnalyticsEvents';

export enum ProductActionTypes {
    LOAD_PRODUCT_LIST = '@@product/LOAD_LIST',
    LOAD_PRODUCT_LIST_SUCCESS = '@@product/LOAD_SUCCESS',
    LOAD_PRODUCT_ERROR = '@@product/LOAD_ERROR',
    LOAD_BILLING_PLANS = '@@product/LOAD_BILLING_PLANS',
    BILLING_PLANS_LOADED = '@@product/BILLING_PLANS_LOADED',
    LOADING_BILLING_PLANS_ERROR = '@@product/LOADING_BILLING_PLANS_ERROR',
    CHANGE_PRODUCT = '@@product/CHANGE_PRODUCT',
}

export interface ProductGetListStart extends Action {
    type: ProductActionTypes.LOAD_PRODUCT_LIST;
}

export interface ProductGetListSuccess extends Action {
    type: ProductActionTypes.LOAD_PRODUCT_LIST_SUCCESS;
    payload: {
        dashboards: DashboardProduct[];
    };
}

export interface ProductGetListError extends Action {
    type: ProductActionTypes.LOAD_PRODUCT_ERROR;
}

export interface ProductListState {
    dashboards: DashboardProduct[];
    addons?: DashboardProduct[];
    isLoading: boolean;
    billingPlans: BillingPlan[];
}

export interface DashboardProduct extends Product {
    dashboardURL: string;
}

export interface LoadBillingPlans extends Action {
    type: ProductActionTypes.LOAD_BILLING_PLANS;
    payload: {
        billingPlanCode: ProductCode;
    };
}

export interface BillingPlansLoaded extends Action {
    type: ProductActionTypes.BILLING_PLANS_LOADED;
    payload: {
        billingPlans: BillingPlan[];
    };
}

export interface LoadingBillingPlansError extends Action {
    type: ProductActionTypes.LOADING_BILLING_PLANS_ERROR;
}

// additional eventLabel payload parameter to remove after A/B tests
export interface ChangeProductAction extends Action {
    type: ProductActionTypes.CHANGE_PRODUCT;
    payload: {
        billingPlanID: number;
        defaultTier: number;
        eventLabel?: GoogleAnalyticsEventsEnum;
    };
}
